import { gql } from '@apollo/client';

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on Address {
    id
    city
    state
    streetLine1
    streetLine2
    zipCode
  }
`;
